// Mirrors backend App\Enums\Payment\SavedPaymentMethodType
// Distinct concept from PaymentMethodType — this describes a saved/tokenized payment method's
// underlying kind (as returned by the payment provider), not the checkout-time selection.

export type SavedPaymentMethodType = 'card' | 'us_bank_account'

export const SavedPaymentMethodType = {
  CARD: 'card',
  BANK_ACCOUNT: 'us_bank_account'
} satisfies Record<string, SavedPaymentMethodType>

export const SavedPaymentMethodTypeValues: readonly SavedPaymentMethodType[] =
  Object.values(SavedPaymentMethodType)
